/** What `loadDictionary` resolves to: the `@words-happen/dictionary/words` module. */
export type DictionaryModule = typeof import('./words-entry');

/**
 * Loads the word list with a dynamic `import()`, so a bundler gives it a chunk of its own, fetched when this is
 * first called rather than with the page. The module is cached like any other, so a second call costs nothing.
 *
 * ```ts
 * const { dictionaryFor } = await loadDictionary();
 * dictionaryFor(puzzle.dictionaryVersion).isWord('THREAD');
 * ```
 */
export const loadDictionary = (): Promise<DictionaryModule> => import('./words-entry');
